// @flow
import React, { useContext, type Node } from 'react'
import { Fieldset } from 'sarsaparilla'

import { LayoutControlContext } from './DetailedAvailabilityPageLayout'

type PropTypes = {
    id?: string,
    children: Node,
    mobileLabel?: string,
}
const DetailedAvailabilityFilterItem = ({
    id,
    children,
    mobileLabel,
}: PropTypes) => {
    const { isMobileApp } = useContext(LayoutControlContext)

    if(isMobileApp && mobileLabel) {
        return (
            <Fieldset id={id} label={mobileLabel} isLabelVisible>
                {children}
            </Fieldset>
        )
    }

    return children;
}

export default DetailedAvailabilityFilterItem;
